import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=077fa088&scoped=true"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"
import style0 from "./Analytics.vue?vue&type=style&index=0&id=077fa088&lang=scss"
import style1 from "./Analytics.vue?vue&type=style&index=1&id=077fa088&scoped=true&lang=css"
import style2 from "../css/utilities/analytics.css?vue&type=style&index=2&lang=css&external"
import style3 from "../css/utilities/scoped/analytics.css?vue&type=style&index=3&id=077fa088&scoped=true&lang=css&external"
import style4 from "../css/dealio.scss?vue&type=style&index=4&id=077fa088&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fa088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077fa088')) {
      api.createRecord('077fa088', component.options)
    } else {
      api.reload('077fa088', component.options)
    }
    module.hot.accept("./Analytics.vue?vue&type=template&id=077fa088&scoped=true", function () {
      api.rerender('077fa088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Analytics.vue"
export default component.exports